// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Qa1I","field":"styles_field__1tu6W","fieldCol":"styles_fieldCol__2GsLO","diffCol":"styles_diffCol__2xDHS","diff":"styles_diff__3ku_Y"};